module.exports = __webpack_public_path__ + "img/gallery-thumbnails.b1ed6da4.svg";